module.exports = __webpack_public_path__ + "static/media/gameNft.d3dfd401.svg";